import * as types from './constants'

const initialState = {
  body: '',
  welcomeBody: `
				<h2 style="color:black;">LOGGING IN</h2>
				<p style="font-size:14px;color:black;">
				To log in, <a href='${window.location.protocol}//${window.location.host}'><span>click here</span></a> and use the email address this message was sent to as your Username and this Temporary Password: <Strong>[default_password]</Strong>
				</p>				
				<p style="font-size:14px;color:black;">Once you log in,you will be prompted to change your password. You can log in on any computer, tablet, or smartphone.</p>		
				<p style="font-size:14px;color:black;">Please contact your adminstrator with any questions.</p>
						
				<p style="font-size:14px;color:black;">Happy Learning!</p>		
				
				<p style="font-size:14px;color:black;">[academyname] Team</p>	
			`,
  subject: '',
  welcomeSubject: 'Welcome to [academyname]',
  lastActivity: {},
  userLoaded: false,
  lastActivityLoaded: false,
  first_name: '',
  last_name: '',
  extra_field_1: '',
  extra_field_2: '',
  avatarFile: null,
  profileSavingStatus: '',
  access: 3,
  user: {
    first_name: '',
    last_name: '',
    extra_field_1: '',
    extra_field_2: '',
    groups: [],
    access: 3,
    second_access: null,
    email: '',
    password: '',
    birthdate: '',
    lastHireDate: '',
    code: '',
    title: '',
    location: [],
    region: [],
    status: 1,
    courses: [],
    stores: [],
    externalReports: [],
    username: '',
    roles: [],
    secondAccessStores: [],
    lockUserData: false,
    isArchived: false,
    archived: 0,
    allowRolesSwitch: false,
    feedIgnore: false,
    isWelcomeEmailButtonDisabled: false,
    extra_field_1: '',
    extra_field_2: '',
  },
  allRoles: [],
  stores: [],
  users: [],
  assignableUsers: [],
  allStores: [],
  allSecondAccessStores: [],
  csv: {},
  csvFile: null,
  uploadCSVPercent: 0,
  uploadCSVStatus: '',
  showArchivedUsers: false,
  passwordSavingStatus: '',
  password: '',
  newPassword: '',
  confirmNewPassword: '',
  searchValue: '',
  totalNumberOfUsers: 0,
  userSubmissions: [],
  isLoading: false,
  showSelectedUsersItems: false,
  isSecondAccess: false,
  usersExtendedDetails: [],
  usersHaveChanges: false,
  usersRowData: [],
  currentPaginationPage: 0,
  totalPaginationPages: 0,
  currentPaginationOffset: 0,
  hasActiveFilters: false,
  activeFilters: {},
  firstNameFilter: '',
  lastNameFilter: '',
  extraField1Filter: '',
  extraField2Filter: '',
  lastLoginFilter: '',
  emailFilter: '',
  usernameFilter: '',
  externalIdFilter: '',
  archivedFilter: '',
  statusFilter: '',
  rolesFilter: [],
  accessFilter: [],
  storesFilter: [],
  locationGroupsFilter: [],
  activePages: [1, 6],
  userNavigation: [],
  settingsModules: [],
  dataModules: [],
  userRewards: [],
  userRoles: [],
  archivedUsers: [],
  managerApprovalUsers: [],
  groupManagerApprovalUsers: [],
  creatingLoading: false,
  selectedOrgGroups: [],
  selectedUsers: [],
  selectedLocationGroups: [],
  selectedLocations: [],
  selectedRoles: [],
  selectedStores: [],
  currentTab: 'category',
  currentItems: 'groupOrgs',
  currentSelectedItems: 'selectedOrgGroups',
  currentToggleFunction: 'toggleOrgGroups',
  assignSearchValue: '',
  showSelectedOrgGroups: false,
  showSelectedUsers: false,
  showSelectedLocationGroups: false,
  showSelectedLocations: false,
  showSelectedStores: false,
  showSelectedRoles: false,
  currentHideSelectedItemsFunction: 'setHideSelectedOrgGroups',
  currentShowSelectedItemsFunction: 'setShowSelectedOrgGroups',
  currentShowSelectedItems: 'showSelectedOrgGroups',
  notLoggedInUsers: [],
}

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ME:
      return {
        ...state,
        ...action.me,
      }
    case types.ON_CHANGE_EMAIL_SUBJECT:
      return {
        ...state,
        subject: action.payload,
      }
    case types.ON_CHANGE_WELCOME_EMAIL_SUBJECT:
      return {
        ...state,
        welcomeSubject: action.payload,
      }
    case types.ON_CHANGE_EMAIL_BODY:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.ON_CHANGE_WELCOME_EMAIL_BODY:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.SET_WELCOME_EMAIL_TEMPLATE:
      return {
        ...state,
        welcomeSubject: action.payload.welcomeSubject || state.welcomeSubject,
        welcomeBody: action.payload.welcomeBody || state.welcomeBody,
      }
    case types.SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.currentTab,
      }
    case types.SET_SELECTED_ORG_GROUPS:
      return {
        ...state,
        selectedOrgGroups: action.orgGroups,
      }
    case types.SET_SELECTED_USERS:
      return {
        ...state,
        selectedUsers: action.users,
      }
    case types.SET_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        selectedLocationGroups: action.locationGroups,
      }
    case types.SET_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.locations,
      }
    case types.SET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case types.SET_SELECTED_STORES:
      return {
        ...state,
        selectedStores: action.stores,
      }
    case types.SET_ASSIGN_SEARCH_VALUE:
      return {
        ...state,
        assignSearchValue: action.assignSearchValue,
      }
    case types.RESET_SELECTED_ITEMS:
      return {
        ...state,
        selectedLocationGroups: [],
        selectedLocations: [],
        selectedStores: [],
        selectedOrgGroups: [],
        selectedRoles: [],
        selectedUsers: [],
      }
    case types.SET_CURRENT_ITEMS:
      return {
        ...state,
        currentItems: action.currentItems,
      }
    case types.SET_CURRENT_SELECTED_ITEMS:
      return {
        ...state,
        currentSelectedItems: action.currentSelectedItems,
      }
    case types.SET_CURRENT_TOGGLE_ITEM_FUNCTION:
      return {
        ...state,
        currentToggleFunction: action.currentToggleFunction,
      }
    case types.SET_SHOW_SELECTED_ORG_GROUPS:
      return {
        ...state,
        showSelectedOrgGroups: action.showSelectedOrgGroups,
      }
    case types.SET_SHOW_SELECTED_USERS:
      return {
        ...state,
        showSelectedUsers: action.showSelectedUsers,
      }
    case types.SET_SHOW_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        showSelectedLocationGroups: action.showSelectedLocationGroups,
      }
    case types.SET_SHOW_SELECTED_LOCATIONS:
      return {
        ...state,
        showSelectedLocations: action.showSelectedLocations,
      }
    case types.SET_SHOW_SELECTED_STORES:
      return {
        ...state,
        showSelectedStores: action.showSelectedStores,
      }
    case types.SET_SHOW_SELECTED_ROLES:
      return {
        ...state,
        showSelectedRoles: action.showSelectedRoles,
      }
    case types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentHideSelectedItemsFunction:
          action.currentHideSelectedItemsFunction,
      }
    case types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentShowSelectedItemsFunction:
          action.currentShowSelectedItemsFunction,
      }
    case types.SET_CURRENT_SHOW_SELECTED_ITEMS:
      return {
        ...state,
        currentShowSelectedItems: action.currentShowSelectedItems,
      }

    case types.SET_CREATING_LOADING:
      return {
        ...state,
        creatingLoading: action.payload,
      }
    case types.LAST_ACTIVITY:
      return {
        ...state,
        lastActivity: action.lastActivity,
      }
    case types.LOADING:
      return {
        ...state,
        [action.loadingType]: action.isLoading,
      }
    case types.USER_ON_CHANGE:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.USER_PROFILE_SAVE:
      return {
        ...state,
        profileSavingStatus: action.status,
      }
    case types.USER_PASSWORD_SAVE:
      return {
        ...state,
        passwordSavingStatus: action.status,
      }
    case types.USER_PASSWORD_CHANGE:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.USER_AVATAR:
      return state
    case types.CURRENT_USER_ON_CHANGE:
      return {
        ...state,
        user: {
          ...state.user,
          [action.name]: action.value,
        },
      }
    case types.SELECT_COURSE:
      return {
        ...state,
        user: {
          ...state.user,
          courses: action.courses,
        },
      }
    case types.SELECT_EXTERNAL_REPORT:
      return {
        ...state,
        user: {
          ...state.user,
          externalReports: action.externalReports,
        },
      }
    case types.SET_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data,
        },
      }
    case types.SET_USER_DETAILS:
      return {
        ...state,
        user: {
          ...state.user,
          courses: action.courses,
        },
      }
    case types.SET_USERS:
      return {
        ...state,
        users: action.data,
      }
    case types.SET_ASSIGNABLE_USERS:
      return {
        ...state,
        assignableUsers: action.data,
      }
    case types.RESET_USER:
      return {
        ...state,
        user: initialState.user,
        isSecondAccess: initialState.isSecondAccess,
      }
    case types.SET_STORES:
      return {
        ...state,
        allStores: action.data,
      }
    case types.SELECT_STORE:
      return {
        ...state,
        user: {
          ...state.user,
          stores: action.stores,
        },
      }
    case types.SET_ROLE_SWITCH:
      return {
        ...state,
        user: {
          ...state.user,
          allowRolesSwitch: !state.user.allowRolesSwitch,
        },
      }
    case types.SET_IGNORE_FEED:
      return {
        ...state,
        user: {
          ...state.user,
          feedIgnore: !state.user.feedIgnore,
        },
      }
    case types.SET_SHOW_IN_MANAGER_REPORT:
      return {
        ...state,
        user: {
          ...state.user,
          showInManagerReport: action.payload,
        },
      }
    case types.TOGGLE_SHOW_IN_MANAGER_REPORT:
      return {
        ...state,
        user: {
          ...state.user,
          showInManagerReport: !state.user.showInManagerReport,
        },
      }
    case types.SET_ROLE_SWITCH_FROM_BACK:
      return {
        ...state,
        user: {
          ...state.user,
          allowRolesSwitch: true,
        },
      }

    case types.SET_FEED_IGNORE_FROM_BACK:
      return {
        ...state,
        user: {
          ...state.user,
          feedIgnore: true,
        },
      }
    case types.SELECT_SECOND_ACCESS_STORE:
      return {
        ...state,
        user: {
          ...state.user,
          secondAccessStores: action.stores,
        },
      }
    case types.CSV_FILE:
      return {
        ...state,
        csvFile: action.file,
      }
    case types.UPLOAD_CSV_STATUS:
      return {
        ...state,
        uploadCSVStatus: action.status,
      }
    case types.UPLOAD_CSV_PERCENT:
      return {
        ...state,
        uploadCSVPercent: action.percent,
      }
    case types.TOGGLE_ARCHIVED_USERS:
      return {
        ...state,
        showArchivedUsers: !state.showArchivedUsers,
      }
    case types.SEARCH_USERS:
      return {
        ...state,
        searchValue: action.value,
      }
    case types.SET_USERS_DETAILS:
      return {
        ...state,
        ...action.data,
      }
    case types.SET_USER_GROUPS:
      return {
        ...state,
        user: {
          ...state.user,
          groups: action.groups,
        },
      }
    case types.SET_USER_LOCATIONS:
      return {
        ...state,
        user: {
          ...state.user,
          location: action.location,
        },
      }
    case types.SET_USER_REGIONS:
      return {
        ...state,
        user: {
          ...state.user,
          region: action.region,
        },
      }
    case types.SET_USER_SUBMISSIONS:
      return {
        ...state,
        userSubmissions: action.submissions,
      }
    case types.ON_LOAD:
      return {
        ...state,
        isLoading: action.isLoading,
      }
    case types.MERGE_GROUPS_LOCATIONS:
      return {
        ...state,
        user: {
          ...state.user,
          groups: action.groups,
        },
      }
    case types.SET_ROLES:
      return {
        ...state,
        allRoles: action.roles,
      }
    case types.SELECT_ROLES:
      return {
        ...state,
        user: {
          ...state.user,
          roles: action.roles,
        },
      }
    case types.SET_SHOW_SELECTED_USERS_ITEMS:
      return {
        ...state,
        showSelectedUsersItems: action.showSelectedUsersItems,
      }
    case types.SET_TOGGLE_SECOND_ACCESS:
      return {
        ...state,
        isSecondAccess: action.isSecondAccess,
      }
    case types.SET_SELECTED_SECOND_ACCESS:
      return {
        ...state,
        user: {
          ...state.user,
          second_access: action.second_access,
        },
      }
    case types.SET_TOGGLE_LOCK_USER_DATA:
      return {
        ...state,
        user: {
          ...state.user,
          lockUserData: !state.user.lockUserData,
        },
      }
    case types.SET_LOCK_USER_DATA:
      return {
        ...state,
        user: {
          ...state.user,
          lockUserData: action.lock_user_data,
        },
      }
    case types.SET_WELCOME_EMAIL_BUTTON_DISABLED:
      return {
        ...state,
        user: {
          ...state.user,
          isWelcomeEmailButtonDisabled: action.isWelcomeEmailButtonDisabled,
        },
      }
    case types.SET_TOGGLE_ARCHIVED:
      return {
        ...state,
        user: {
          ...state.user,
          isArchived: !state.user.isArchived,
        },
      }
    case types.SET_USER_ARCHIVED:
      return {
        ...state,
        user: {
          ...state.user,
          isArchived: action.isArchived,
        },
      }
    case types.SET_USER_BIRTHDATE:
      return {
        ...state,
        user: {
          ...state.user,
          birthdate: action.date,
        },
      }
    case types.SET_USER_LAST_HIRE_DATE:
      return {
        ...state,
        user: {
          ...state.user,
          lastHireDate: action.date,
        },
      }
    case types.SET_USERS_EXTENDED_DETAILS:
      return {
        ...state,
        usersExtendedDetails: action.data,
      }
    case types.SET_USERS_HAVE_CHANGES:
      return {
        ...state,
        usersHaveChanges: action.value,
      }
    case types.SET_USERS_ROWS_DATA:
      return {
        ...state,
        usersRowData: action.value,
      }
    case types.SET_USERS_COLUMN_DATA:
      return {
        ...state,
        usersColumnData: action.value,
      }
    case types.SET_CURRENT_PAGINATION_PAGE:
      return {
        ...state,
        currentPaginationPage: action.value,
      }
    case types.SET_TOTAL_PAGINATION_PAGES:
      return {
        ...state,
        totalPaginationPages: action.value,
      }
    case types.SET_CURRENT_PAGINATION_OFFSET:
      return {
        ...state,
        currentPaginationOffset: action.value,
      }
    case types.SET_TOTAL_NUMBER_OF_USERS:
      return {
        ...state,
        totalNumberOfUsers: action.value,
      }
    case types.SET_HAS_ACTIVE_FILTERS:
      return {
        ...state,
        hasActiveFilters: action.value,
      }
    case types.SET_ACTIVE_FILTERS:
      return {
        ...state,
        activeFilters: action.value,
      }
    case types.SET_FIRST_NAME_FILTER:
      return {
        ...state,
        firstNameFilter: action.value,
      }
    case types.SET_LAST_NAME_FILTER:
      return {
        ...state,
        lastNameFilter: action.value,
      }
    case types.SET_EXTRA_FIELD_1_FILTER:
      return {
        ...state,
        extraField1Filter: action.value,
      }
    case types.SET_EXTRA_FIELD_2_FILTER:
      return {
        ...state,
        extraField2Filter: action.value,
      }
    case types.SET_LAST_LOGIN_FILTER:
      return {
        ...state,
        lastLoginFilter: action.value,
      }
    case types.SET_EMAIL_FILTER:
      return {
        ...state,
        emailFilter: action.value,
      }
    case types.SET_USERNAME_FILTER:
      return {
        ...state,
        usernameFilter: action.value,
      }
    case types.SET_EXTERNAL_ID_FILTER:
      return {
        ...state,
        externalIdFilter: action.value,
      }
    case types.SET_SELECTED_ROLES_FILTER:
      return {
        ...state,
        rolesFilter: action.value,
      }
    case types.SET_SELECTED_ACCESS_FILTER:
      return {
        ...state,
        accessFilter: action.value,
      }
    case types.SET_SELECTED_STORES_FILTER:
      return {
        ...state,
        storesFilter: action.value,
      }
    case types.SET_SELECTED_STATUS_FILTER:
      return {
        ...state,
        statusFilter: action.value,
      }
    case types.SET_SELECTED_LOCATION_GROUPS_FILTER:
      return {
        ...state,
        locationGroupsFilter: action.value,
      }
    case types.REMOVE_FILTER:
      return {
        ...state,
        [action.name]: initialState[action.name],
      }
    case types.RESET_FILTERS:
      return {
        ...state,
        firstNameFilter: '',
        lastNameFilter: '',
        extraField1Filter: '',
        extraField2Filter: '',
        lastLoginFilter: '',
        emailFilter: '',
        usernameFilter: '',
        externalIdFilter: '',
        statusFilter: '',
        archivedFilter: '',
        rolesFilter: [],
        accessFilter: [],
        storesFilter: [],
        locationGroupsFilter: [],
      }
    case types.SET_ACTIVE_PAGES:
      return {
        ...state,
        activePages: action.value,
      }
    case types.SET_SHOW_ARCHIVED_USERS:
      return {
        ...state,
        showArchivedUsers: action.value,
      }
    case types.SET_ARCHIVED_FILTER:
      return {
        ...state,
        archivedFilter: action.value,
      }

    case types.SET_ARCHIVED_FILTER_TRUE:
      return {
        ...state,
        archivedFilter: 1,
      }
    case types.SET_USER_PRIVILEGES:
      return {
        ...state,
        userNavigation: action.mainModules,
        settingsModules: action.settingsModules,
        dataModules: action.dataModules,
      }
    case types.SET_USER_REWARDS:
      return {
        ...state,
        userRewards: action.data,
      }
    case types.SET_USER_ROLES:
      return {
        ...state,
        userRoles: action.userRoles,
      }

    case types.SET_ARCHIVED_USERS:
      return {
        ...state,
        archivedUsers: action.data,
      }
    case types.SET_MANAGER_APPROVAL_USERS:
      return {
        ...state,
        managerApprovalUsers: action.data,
      }
    case types.SET_GROUP_MANAGER_APPROVAL_USERS:
      return {
        ...state,
        groupManagerApprovalUsers: action.data,
      }

    case types.SET_NOT_LOGGED_IN_USERS:
      return {
        ...state,
        notLoggedInUsers: action.payload,
      }

    default:
      return state
  }
}

export default usersReducer
